var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cloud
    ? _c(
        "div",
        {
          staticClass: "lite_popup lite_business_cloud_popup",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "lite_popup_box lite_business_cloud_box",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _vm.title
              }
            },
            [
              _c("div", { staticClass: "lite_popup_title" }, [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "icon white-close lite_business_close",
                  attrs: {
                    type: "button",
                    disabled: !!_vm.connecting,
                    "aria-label": _vm.$t("language.common.close")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "lite_business_cloud_content" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "language.popup.addCloudPopup." + _vm.cloud.description
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "lite_business_cloud_note",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "language.popup.addCloudPopup.specialDropBoxBottom"
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "lite_business_cloud_actions" }, [
                  _c(
                    "button",
                    {
                      attrs: { type: "button", disabled: !!_vm.connecting },
                      on: {
                        click: function($event) {
                          return _vm.$emit("select", "organization")
                        }
                      }
                    },
                    [
                      _vm.connecting === "organization"
                        ? [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.connecting"))
                            ),
                            _c("span", { staticClass: "cloudDotting" })
                          ]
                        : [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.addCloudPopup.accessOrganization"
                                )
                              )
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "lite_business_personal",
                      attrs: { type: "button", disabled: !!_vm.connecting },
                      on: {
                        click: function($event) {
                          return _vm.$emit("select", "personal")
                        }
                      }
                    },
                    [
                      _vm.connecting === "personal"
                        ? [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.connecting"))
                            ),
                            _c("span", { staticClass: "cloudDotting" })
                          ]
                        : [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.addCloudPopup.accessPersonalCloud"
                                )
                              )
                            )
                          ]
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-696b7c47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696b7c47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/lite_business_cloud_popup.vue
// module id = null
// module chunks = 